/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { MetypeFeedWidget } from "@metype/components";
export default MetypeFeedWidget;
